import { render, staticRenderFns } from "./BusinessInquiryRegistration.vue?vue&type=template&id=399c35f0&scoped=true"
import script from "./BusinessInquiryRegistration.vue?vue&type=script&lang=js"
export * from "./BusinessInquiryRegistration.vue?vue&type=script&lang=js"
import style0 from "./BusinessInquiryRegistration.vue?vue&type=style&index=0&id=399c35f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399c35f0",
  null
  
)

export default component.exports